export default {
  priceAmount: '$XXX.XXX.XX'
};
